import { Box, Tooltip } from "@mui/material";
import { FilterButton, useListContext } from "react-admin";

const CustomFilterButton = ({ ...props }) => {
  const { total, filterValues, showFilter, hideFilter, displayedFilters } =
    useListContext();
  const filterFieldLength = Object.keys(displayedFilters).length;
  // Count only valid filters that have a value and displayed
  // const validFilterCount = Object.keys(filterValues).filter(
  //   (key) => filterValues[key] && displayedFilters[key]
  // ).length;
  // console.log("validFilterCount===>", displayedFilters, filterFieldLength);
  return filterFieldLength >= 3 ? (
    <Tooltip title="Can't save more than 3 filters" placement="left">
      <span>
        <FilterButton
          style={{
            width: "120px",
            minWidth: "120px",
            color: "primary.main",
            pointerEvents: "none",
            opacity: 0.5,
          }}
          disableSaveQuery={true}
        />
      </span>
    </Tooltip>
  ) : (
    <Box
      sx={{
        "& button": {
          width: "120px",
          minWidth: "120px",
        },
      }}
    >
      <FilterButton
        id="btn-list-filter"
        style={{
          width: "120px",
          minWidth: "120px",
          color: "primary.main",
          textAlign: "center",
        }}
        disableSaveQuery={true}
      />
    </Box>
  );
};

export default CustomFilterButton;
